"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasValidNumberOfGolfers = void 0;
const dayjs = require("dayjs");
const hasValidNumberOfGolfers = (start_date, end_date, golferCount, contracts, maxYearsBack = 2) => {
    // Helper function to check contracts for specific dates
    const checkContractsForDates = (checkStart, checkEnd, contracts) => {
        if (contracts.length === 0)
            return false;
        // Filter contracts to only include those that have products with rates matching golfer count
        const validContracts = contracts.filter((contract) => {
            if (!contract.products?.length)
                return false;
            return contract.products.some((product) => {
                if (!product.rates?.length)
                    return false;
                return product.rates.some((rate) => golferCount >= rate.min_pax);
            });
        });
        if (validContracts.length === 0)
            return false;
        // Check if any contract overlaps with the trip period
        return validContracts.some((contract) => {
            const contractStart = dayjs(contract.start_date);
            const contractEnd = dayjs(contract.end_date);
            return ((contractStart.isSameOrBefore(checkEnd) &&
                contractEnd.isSameOrAfter(checkStart)) ||
                (contractStart.isSameOrBefore(checkStart) &&
                    contractEnd.isSameOrAfter(checkStart)));
        });
    };
    // Helper function to find the closest matching day of week in previous year
    const findClosestMatchingDayInPreviousYear = (date, yearsBack) => {
        const targetDayOfWeek = date.day();
        const previousYear = date.subtract(yearsBack, "year");
        // Check the exact date in previous year and nearby dates (±3 days)
        let closestDate = previousYear;
        let minDiff = Math.abs(closestDate.day() - targetDayOfWeek);
        for (let i = -3; i <= 3; i++) {
            const checkDate = previousYear.add(i, "day");
            const diff = Math.abs(checkDate.day() - targetDayOfWeek);
            if (diff < minDiff) {
                minDiff = diff;
                closestDate = checkDate;
            }
            // If we found an exact match, no need to check further
            if (diff === 0)
                break;
        }
        return closestDate;
    };
    const tripStart = dayjs(start_date);
    const tripEnd = dayjs(end_date);
    // First try with original dates
    if (checkContractsForDates(tripStart, tripEnd, contracts)) {
        return true;
    }
    // If no valid contracts found, try previous years
    for (let yearsBack = 1; yearsBack <= maxYearsBack; yearsBack++) {
        const adjustedStart = findClosestMatchingDayInPreviousYear(tripStart, yearsBack);
        const adjustedEnd = findClosestMatchingDayInPreviousYear(tripEnd, yearsBack);
        if (checkContractsForDates(adjustedStart, adjustedEnd, contracts)) {
            return true;
        }
    }
    return false;
};
exports.hasValidNumberOfGolfers = hasValidNumberOfGolfers;
